import angular from 'angular'
import uirouter from 'angular-ui-router'

import routing from './article.routes'
import ArticleService from './article.service'
import ArticleCard from './article-card.directive'
import ArticleFormDirective from './article-form.directive'
import ArticleCategoriesSlideoutDirective from './categories-slideout.directive'
import ArticlesController from './articles.controller'
import ArticleController from './article.controller'
import NewArticleController from './new-article.controller'
import ViewArticleController from './view-article.controller'
import './article.less'

export default angular.module('app.article', [uirouter, ArticleCard])
  .config(routing)
  .service('ArticleService', ArticleService)
  .directive('articleForm', ArticleFormDirective)
  .directive('articleCategoriesSlideout', ArticleCategoriesSlideoutDirective)
  .controller('ArticlesController', ArticlesController)
  .controller('ArticleController', ArticleController)
  .controller('NewArticleController', NewArticleController)
  .controller('ViewArticleController', ViewArticleController)
  .name